import {
  faUserSecret, // circle user secret
  faUserCircle,
  faCheckCircle, // check circle
  faExclamationCircle,
  faArrowLeft,
  faChevronRight, // flecha derecha >
  faArrowDown, // flecha para abajo,
  faArrowUp, // flecha para arriba,
  faAngleDown, // tipo de flecha corta para abajo
  faAngleUp, // tipo de flecha corta para abajo
  faCircleNotch,
  faTimes, // equis
  faTrashAlt, // basurero
  faLocationArrow, // gps triangular
  faUser, // icono usuario
  faPaperPlane, // avion de pael
  faIdCard, // documento frontal
  faVrCardboard, // tarjetero
  faScroll, // pergamino
  faHome, // casa
  faCalendarAlt, // calendario
  faStore, // local, tienda
  faFileSignature, // firma
  faShoppingCart,
  faBars, // bara de menu
  faCog, // configuraciones,
  faSync, // actualizar
  faSignInAlt, // logout
  faSolarPanel,
  faKey, // llave
  faPlus, // mas
  faLayerGroup, // cuadrados encima,
  faEdit,
  faMap,
  faExchangeAlt, // flecha entrelazadas,
  faCopy, // libro copiado
  faQuestionCircle, // pregunta,
  faPhone,
  faHandshake, // trato hecho
  faSearch,
  faTruckPickup,
  faStoreAlt, // store diferente
  faBus,
  faCarSide, // carro con edificio
  faBuilding, //edificio
  faArchive,
  faEllipsisVertical, // menu
  faEnvelope, // email,
  faFileExcel,
  faCamera,

} from '@fortawesome/free-solid-svg-icons';

export const icons = [
  faUserSecret,
  faUserCircle,
  faCheckCircle,
  faExclamationCircle,
  faArrowLeft,
  faChevronRight,
  faArrowDown,
  faAngleDown,
  faAngleUp,
  faArrowUp,
  faCircleNotch,
  faTimes,
  faTrashAlt,
  faLocationArrow,
  faUser,
  faPaperPlane,
  faIdCard,
  faVrCardboard,
  faScroll,
  faHome,
  faCalendarAlt,
  faStore,
  faFileSignature,
  faShoppingCart,
  faBars,
  faCog,
  faSync,
  faSignInAlt,
  faSolarPanel,
  faKey,
  faPlus,
  faLayerGroup,
  faEdit,
  faMap,
  faExchangeAlt,
  faCopy,
  faQuestionCircle,
  faPhone,
  faHandshake,
  faSearch,
  faTruckPickup,
  faStoreAlt,
  faBus,
  faCarSide,
  faBuilding,
  faArchive,
  faEllipsisVertical,
  faEnvelope,
  faFileExcel,
  faCamera,
];
